import { useContext } from 'react'

import BlurryBackgroundContext from '@contexts/blurryBackground'

const useHasBlurryBackground = (): boolean =>
  !!useContext(BlurryBackgroundContext)

export default useHasBlurryBackground
